export default __webpack_public_path__ + "static/media/blustreamLogo.2b0929a1.svg";